/* eslint-disable max-classes-per-file */
import { createAction, props } from '@ngrx/store';
import { Credentials } from './login.model';
import { TwoFACode } from '@app/auth/core/state/auth.model';
import { BackupCode } from '@app/auth/models';

export const ActionTypes = {
  LOGIN: '[Auth] Login',
  LOGIN_SUCCESS: '[Auth] Login Success',
  LOGIN_FAILURE: '[Auth] Login Failure',
  LOGIN_CHECK_EMAIL_DOMAIN: '[Auth] Login check SSO',
  LOGIN_SHOW_PASSWORD: '[Auth] Login show password',
  LOGIN_TO_AZURE_AD_SUCCESS: '[Auth] Login to azure ad success',
  VERIFY_2FA_CODE: '[Auth] Verify 2FA Code',
  VERIFY_2FA_VIA_RECOVERY_CODE: '[Auth] Verify 2FA Via Recovery Code',
  VERIFY_2FA_CODE_FAILURE: '[Auth] Verify 2FA Code or Backup Failure',
};

export const login = createAction(
  ActionTypes.LOGIN,
  props<{ payload: Credentials }>()
);

export const loginSuccess = createAction(
  ActionTypes.LOGIN_SUCCESS
);

export const loginFailure = createAction(
  ActionTypes.LOGIN_FAILURE,
  props<{
    payload: {
      error: string;
      attemptsLeft?: number;
      bannedTime?: number;
    }
  }>()
);

export const loginVerify2FACode = createAction(
  ActionTypes.VERIFY_2FA_CODE,
  props<{ payload: TwoFACode }>()
);

export const loginVerify2FACodeFailure = createAction(
  ActionTypes.VERIFY_2FA_CODE_FAILURE,
  props<{
    payload: { code: string } | {
      attemptsLeft: number;
      banned: number;
      message: string;
    }
  }>()
);

export const loginShowPassword = createAction(
  ActionTypes.LOGIN_SHOW_PASSWORD
);

export const loginToAzureADSuccess = createAction(
  ActionTypes.LOGIN_TO_AZURE_AD_SUCCESS
);

export const loginCheckEmailDomain = createAction(
  ActionTypes.LOGIN_CHECK_EMAIL_DOMAIN,
  props<{ payload: string }>()
);

export const recoveryVerifyCode = createAction(
  ActionTypes.VERIFY_2FA_VIA_RECOVERY_CODE,
  props<BackupCode>()
);
